// ** React Imports
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmissioByClassificationSlug,
  getClassificationById,
} from "@store/action/planning/EmissionAction";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FilterBlog from "./FilterBlog";
import Emissions from "./Emissions";
import "@styles/base/pages/app-ecommerce.scss";

const GetEmissionList = () => {
  // ** States
  const [activeView, setActiveView] = useState("list");
  const [currentPage, setCurrentPage] = useState(1);
  const [classificationName, setClassificationName] = useState("");
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const { slug } = useParams();
  const store = useSelector((state) => state.emissions);
  useEffect(() => {
    dispatch(
      getEmissioByClassificationSlug(slug, {
        per_page: 5,
        page: currentPage,
        search: window.location.search,
      })
    );
    return () => {
      dispatch({
        type: "EMPTY_GET_EMISSION_BY_CLASSIFICATION_SLUG",
      });
    };
  }, [dispatch, slug, window.location.search]);
  useEffect(async () => {
    const classification = await getClassificationById(slug);
    setClassificationName(() => classification?.name);
  }, [slug]);

  return (
    <div className="Ushno">
      <section className="single-banner">
        <div className="container__">
          <div className="row">
            <div className="col-lg-12">
              <div className="single-content">
                <h2>
                  {t("emissions with classification") +
                    " : " +
                    classificationName}
                </h2>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">{t("Home")}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Emissions
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-part">
        <div className="container__video">
          <div className="row content-reverse">
            <FilterBlog
              t={t}
              store={store}
              dispatch={dispatch}
              setCurrentPage={setCurrentPage}
              path={`emissions/classification/${slug}`}
            />
            <div className="ecommerce-application col-lg-9">
              <Emissions
                activeView={activeView}
                setActiveView={setActiveView}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                store={store}
                t={t}
                getEmissioByClassificationSlug={getEmissioByClassificationSlug}
                dispatch={dispatch}
                slug={slug}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default GetEmissionList;
